module.exports = __webpack_public_path__ + "static/media/bg-alineamiento.d19387db.png";